@if (lookupList.length) {
  <div [formArrayName]="inputFormControlName()" class="flex flex-col gap-lg">
    <!--
      Header uses the same grid track as the fields so label + close
      align to the field column width (not the full form section).
    -->
    @if (showSharedHeader()) {
      <div
        class="grid [grid-template-columns:repeat(auto-fill,minmax(20rem,1fr))]">
        <ng-container *ngTemplateOutlet="sharedHeader" />
      </div>
    }

    <!-- Selected items fill rows left-to-right.
         Pending (unselected) item is forced to column 1 so it always starts
         on a new row and stays the same width as a selected column. -->
    <div
      class="grid [grid-template-columns:repeat(auto-fill,minmax(20rem,1fr))] gap-lg items-end">
      @for (lookup of lookupList; track lookup.id; let index = $index) {
        @if (lookup.selectedOption) {
          <div>
            <lib-lookup-field
              [id]="id() + '_' + index"
              [inputFormControlName]="index"
              [name]="name() + '_' + index"
              [label]="fieldLabel()"
              [required]="required()"
              [viewOnly]="viewOnly()"
              [placeholder]="placeholder()"
              [apiUrl]="apiUrl()"
              [filters]="filters()"
              [selectedOption]="lookup.selectedOption"
              [labelValueAssignList]="labelValueAssignList()"
              [selectedKeyName]="selectedKeyName()"
              [selectedKeyValue]="selectedKeyValue()"
              [searchPlaceholder]="searchPlaceholder()"
              [detailsNotFoundLabel]="detailsNotFoundLabel()"
              [isMultiLookup]="true"
              [selectedOptionsArray]="childFormArray.value"
              [triggerAction]="effectiveTriggerAction()"
              [parentFieldKey]="parentFieldKey()"
              [searchKeywordKey]="searchKeywordKey()"
              [selectAllLabel]="selectAllLabel()"
              [enableSelectAll]="enableSelectAll()"
              [maxSelectable]="size()?.max_size ?? null"
              (selectedOptionOutput)="selectOption($event, index)"
              (selectAllOptions)="selectAll($event)"
              (clearOption)="handleClearLookup(index)"
              [noSearchResultLabel]="noSearchResultLabel()" />
            <lib-validation-message [lang]="lang()" [control]="index" />
          </div>
        }
      }

      @for (lookup of lookupList; track lookup.id; let index = $index) {
        @if (!lookup.selectedOption) {
          <div class="[grid-column:1]">
            <lib-lookup-field
              [id]="id() + '_' + index"
              [inputFormControlName]="index"
              [name]="name() + '_' + index"
              [label]="fieldLabel()"
              [required]="required()"
              [viewOnly]="viewOnly()"
              [placeholder]="placeholder()"
              [apiUrl]="apiUrl()"
              [filters]="filters()"
              [selectedOption]="lookup.selectedOption"
              [labelValueAssignList]="labelValueAssignList()"
              [selectedKeyName]="selectedKeyName()"
              [selectedKeyValue]="selectedKeyValue()"
              [searchPlaceholder]="searchPlaceholder()"
              [detailsNotFoundLabel]="detailsNotFoundLabel()"
              [isMultiLookup]="true"
              [selectedOptionsArray]="childFormArray.value"
              [triggerAction]="effectiveTriggerAction()"
              [parentFieldKey]="parentFieldKey()"
              [searchKeywordKey]="searchKeywordKey()"
              [selectAllLabel]="selectAllLabel()"
              [enableSelectAll]="enableSelectAll()"
              [maxSelectable]="size()?.max_size ?? null"
              (selectedOptionOutput)="selectOption($event, index)"
              (selectAllOptions)="selectAll($event)"
              (clearOption)="handleClearLookup(index)"
              [noSearchResultLabel]="noSearchResultLabel()" />
            <lib-validation-message [lang]="lang()" [control]="index" />
          </div>
        }
      }
    </div>

    @if (!viewOnly()) {
      <div
        class="grid [grid-template-columns:repeat(auto-fill,minmax(20rem,1fr))]">
        <div>
          <ng-container *ngTemplateOutlet="addNewButton" />
        </div>
      </div>
    }
  </div>
}

<ng-template #sharedHeader>
  <div
    class="flex justify-between items-center gap-md">
    <label
      class="block font-medium text-sm"
      [class.text-neutral-500]="viewOnly()"
      [class.text-xs2]="viewOnly()"
      [class.text-neutral-900]="!viewOnly()">
      {{ label() }}
      @if (required()) {
        <span class="text-destructive-500 text-sm">*</span>
      }
    </label>
    @if (showRemoveUnselected()) {
      <button
        type="button"
        id="multi_lookup_field_remove_button"
        class="bg-transparent border-none p-0 cursor-pointer inline-block leading-none shrink-0"
        (click)="removeUnselectedLookupField()">
        <lib-close-icon
          iconClass="size-5"
          stroke="var(--color-neutral-500)" />
      </button>
    }
  </div>
</ng-template>

<ng-template #addNewButton>
  <button
    type="button"
    (click)="canAddNew() && addLookupOption()"
    class="py-sm pe-lg flex items-center gap-sm bg-transparent font-medium"
    [class.text-primary-600]="canAddNew()"
    [class.text-neutral-300]="!canAddNew()"
    [class.cursor-pointer]="canAddNew()"
    [class.cursor-not-allowed!]="!canAddNew()">
    <lib-add-icon
      [iconClass]="
        'size-4 ' + (canAddNew() ? 'text-primary-600' : 'text-neutral-300')
      " />

    {{ addNewButtonText() }}
  </button>
</ng-template>
